import { Link } from 'react-router-dom'
import { EmptyPlaceholder, PageListUL } from '../styles'
import { ReactComponent as InsertIcon } from 'assets/images/icons/insert.svg'

export function EmptyListCreateDraft(props) {
  return (
    <PageListUL level={props.level || 0}>
      <li>
        <EmptyPlaceholder className='text-muted small'>
          {!props.hideAddDraftLink && (
            <>
              {props.type === 'page' && (
                <Link to={`/pages/drafts/create${props.category && props.category.id ? `?category=${props.category.uuid}` : ''}`}>
                  <InsertIcon /> Create a draft here
                </Link>
              )}
              {props.type === 'response' && (
                <Link to={`/responses/create${props.category && props.category.id ? `?category=${props.category.uuid}` : ''}`}>
                  <InsertIcon /> Create a response here
                </Link>
              )}
            </>
          )}
          {props.hideAddDraftLink && <div className='px-1 py-2'>Nothing here</div>}
        </EmptyPlaceholder>
      </li>
    </PageListUL>
  )
}
